import cx from 'classnames';
import T from 'i18n-react';

import texts from 'Components/texts.json';

import Error from '../Error/Error';

import styles from '../StaticContents.module.scss';

T.setTexts(texts);

const emailTypes = {
	nextSaleAuction: 'nextSaleAuction',
};

type AuctionUnsubscribeProps = {
	display?: 'success' | 'error';
	emailType?: string;
};

const AuctionUnsubscribe: React.FC<AuctionUnsubscribeProps> = ({ display = 'success', emailType = '' }) => {
	if (display === 'error') {
		return <Error button={false} />;
	}

	const unsubscribeMessage = T.translate(
		emailType === emailTypes.nextSaleAuction
			? 'unsubcribePage.nextSaleUnsubscribe'
			: 'unsubcribePage.auctionUnsubscribe',
	);

	return (
		<div className={cx(styles.staticContents, styles.container, styles.center)}>
			<h1>You’ve been unsubscribed</h1>
			<div>
				<p>{unsubscribeMessage}</p>
			</div>
		</div>
	);
};

export default AuctionUnsubscribe;
